module.exports = __webpack_public_path__ + "static/media/store.40bb36e5.svg";